import { inject, Injectable } from '@angular/core';
import { UserService } from '../../core/services/user/user.service';
import { UserDetails } from '../../core/models/user-details';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { EmailMessage } from '../email-models/email-message.interface';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private userService = inject(UserService);
  private httpClient = inject(HttpClient);

  private apiBaseUrl = environment.connectCrmApiUrl;

  userDetails: UserDetails | null = null;

  constructor() {
    this.userService.loggedInRole$.subscribe((userDetails: UserDetails) => {
      this.userDetails = userDetails;
    });
  }

  sendEmail(emailMessage: EmailMessage): Promise<void> {
    if (!this.userDetails?.contextKey || !this.userDetails?.fsp) {
      console.error('Cannot send email: User details not available');
      return Promise.reject('User details not available');
    } else {
      const emailMessageWithUserDetails: EmailMessage = {
        ...emailMessage,
        contextKey: this.userDetails.contextKey,
        fsp: this.userDetails.fsp,
      };

      return firstValueFrom(
        this.httpClient.post<void>(
          `${this.apiBaseUrl}/v1/office365/emails`,
          emailMessageWithUserDetails,
        ),
      ).then(() => {
        console.log('Email sent successfully via API');
      });
    }
  }

}
